import { Suspense } from "react";

import { useRoutes } from 'react-router-dom';

import { ThemeProvider, StyledEngineProvider } from '@mui/material';

import 'react-toastify/dist/ReactToastify.css';

import GlobalStyles from '@components/GlobalStyles';
import "./assets/theme.scss";

import theme from './theme';
import routes from './Routes';

const SUSPENSE_FALLBACK = (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        Loading...
    </div>
);

const App = () => {
    const token = localStorage.getItem('lms_token');
    const content = useRoutes(routes({ isAuthenticated: !!token }));

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <GlobalStyles />
                <Suspense fallback={SUSPENSE_FALLBACK}>
                    {content}
                </Suspense>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
